module.exports = __webpack_public_path__ + "media/img/favicon/favicon-64bd09f93cfc68c8c3141b6136a5f304.ico";